import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getConfig } from "../../services/ConfigService";
import { HttpCodes } from "../../constants/app.constant";
  
export interface State {
  configList: any[];
  allYearsConfigList: any[];
  isConfigLoading: boolean;
}

const initialState: State = {
  configList: [],
  allYearsConfigList: [],
  isConfigLoading: false
};

export const configThunk = createAsyncThunk(
  "config",
  async (payload: any, thunkApi) => {
    try {
      const response = await getConfig(payload);
      if (response.responseCode == HttpCodes.SUCCESS) {
        return response.data || [];
      }
      return [];
    } catch (e) {
      console.log(e);
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    resetConfigState: () => initialState,
    setList: (state, action) => {
      state.configList = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(configThunk.pending, (state, action) => {
      state.isConfigLoading = true;
    });
    builder.addCase(configThunk.fulfilled, (state, action) => {
      state.isConfigLoading = false;
      state.allYearsConfigList.push(action.payload);
      state.configList = action.payload;
    });
    builder.addCase(configThunk.rejected, (state, action) => {
      state.isConfigLoading = false;
      state.configList = [];
    });
  }
});

export const { setList, resetConfigState } = configSlice.actions;

export default configSlice.reducer;
